import React, { useState } from 'react';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { formatNumber } from '@utils/helper';
import { Row, Col, Spin, Statistic, Card, Table } from 'antd';
import { Pie } from '@ant-design/plots';
import RelativeDate from '@common/RelativeDate';
import SumTable from '@common/SumTable';


function SaleReport() {
  const [aovData, setAovData] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [topProductData, setTopProductData] = useState([]);
  const { isLoading, mutate: getCategoryData } = useMutation(({ timeRange }) => {
    const { from, to } = timeRange;
    return request.get(`v1/statistics/sales?type=category&from=${from}&to=${to}`);
  },
    {
      onSuccess: (response) => {
        initCategoryData(response.data);
      },
    })
  const { isLoading: isLoadingAov, mutate: getAov } = useMutation(({ timeRange }) => {
    const { from, to } = timeRange;
    return request.get(`v1/statistics/sales?type=aov&from=${from}&to=${to}`);
  },
    {
      onSuccess: (response) => {
        if(response.data.length){
          setAovData(response.data[0]);
        }
      },
    })
  const { isLoading: isLoadingTopProduct, mutate: getTopProduct } = useMutation(({ timeRange }) => {
    const { from, to } = timeRange;
    return request.get(`v1/statistics/sales?type=topProduct&from=${from}&to=${to}&quantity=20`);
  },
    {
      onSuccess: (response) => {
        setTopProductData(response.data);
      },
    })
  const initCategoryData = (resData) => {
    const data = [];
    resData.forEach(row => {
      const catId = row.categoryId || 0;
      const name = catId ? row.name : 'Khác';
      const ind = data.findIndex(d => d.categoryId === catId);
      if(ind < 0){
        data.push({
          categoryId: catId,
          name,
          qty: parseInt(row.qty),
          total: parseInt(row.total)
        })
      } else {
        data[ind].qty += parseInt(row.qty);
        data[ind].total += parseInt(row.total);
      }
    });
    setCategoryData(data);
  }
  const onChangeDate = (type, timeRange) => {
    setCategoryData([]);
    setAovData({});
    setTopProductData([]);
    getCategoryData({ timeRange });
    getAov({timeRange});
    getTopProduct({timeRange});
  }
  const pieConfig = {
    appendPadding: 10,
    angleField: 'value',
    colorField: 'name',
    radius: 0.9,
    label: {
      type: 'inner',
      offset: '-30%',
      content: ({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: 'center',
      },
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
  };
  const topProductColumn = [
    {
      title: 'Image',
      dataIndex: 'image',
      render: (text, rec) => <img alt={rec.groupName} src={text} height={50} />
    },
    {
      title: 'Name',
      dataIndex: 'groupName',
    },
    {
      title: 'SL',
      dataIndex: 'qty',
      align: 'right',
    },
  ]
  const tableColumn = [
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'SL',
      dataIndex: 'qty',
      align: 'right',
      sorter: (a, b) => a.qty - b.qty,
    },
    {
      title: 'Doanh Thu',
      dataIndex: 'total',
      align: 'right',
      render: formatNumber,
      sorter: (a, b) => a.total - b.total,
    },
  ]
  return (<>
    <Row gutter={16}>
      <Col sm={14}>
        <h2>Báo cáo bán hàng tổng hợp</h2>
      </Col>
      <Col sm={10}>
        <RelativeDate onChange={onChangeDate} />
      </Col>
    </Row>
    <Spin spinning={isLoading || isLoadingAov || isLoadingTopProduct}>
      <Row gutter={12} style={{ marginTop: '2rem' }}>
        <Col sm={12} >
          <Row>
            <Col sm={8}>
              <Card>
                <Statistic title="Đơn hàng" value={aovData.qty} />
              </Card>
            </Col>
            <Col sm={8}>
              <Card>
                <Statistic title="Doanh thu" value={aovData.total} />
              </Card>
            </Col>
            <Col sm={8}>
              <Card>
                <Statistic title="AOV" value={aovData.AOV} />
              </Card>
            </Col>
          </Row>
          <Row gutter={12} style={{ marginTop: '2rem' }}>
            <Col sm={24}>
              <h3>Số lượng</h3>
              <Pie {...pieConfig} angleField='qty' data={categoryData} />
            </Col>
            <Col sm={24}>
              <h3>Doanh thu</h3>
              <Pie {...pieConfig} angleField='total' data={categoryData} />
            </Col>
            <Col sm={24}>
              <SumTable numberColumns={['qty','total']} dataSource={categoryData} columns={tableColumn} rowKey={'categoryId'} />
            </Col>
          </Row>
        </Col>
        <Col sm={12} >
          <Table dataSource={topProductData} columns={topProductColumn} rowKey={'groupName'} className='smallTable' />
        </Col>
      </Row>
    </Spin>
  </>)
}

SaleReport.propTypes = {
};

SaleReport.defaultProps = {
};

export default SaleReport;
